import { Component } from "react"
import { AvailableContent } from "../components/available/AvailableContent"
import { AvailableMap } from "../components/available/AvailableMap"
import { Footer } from "../components/Footer"
import { Header } from "../components/Header"

export class AvailablePage extends Component {
  render = () => (
    <>
      <div className="main__bg">
        <video autoPlay loop muted playsInline poster="img/bg.jpg" className="fullscreen-bg__video">
          <source src="/img/video_bg.mp4" type="video/mp4" />
        </video>
        <div className="main__bg_wrapper">
          <Header />
          <AvailableContent />
        </div>
      </div>

      <AvailableMap />

      <Footer isDark={true} />
    </>
  )
}
